import React, { useContext, useState } from "react";
import { toast } from "sonner";
import { ShieldCheck, Plus, Trash2, Save, Loader2 } from "lucide-react";
import { AuthContext } from "../App";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TIPOS = { exportador: "Inscripto como exportador", no_retencion: "Constancia de no retención" };

/**
 * Catastro → Proveedor: constancias que lo eximen de la retención de IVA.
 * Valen solo para el AÑO indicado (las de 2025 no cubren 2026: hay que cargarlas de nuevo).
 * Se guardan por su cuenta, requieren retenciones.gestionar_constancias.
 */
export default function ConstanciasRetencionBlock({ entidad, token }) {
  const { user, hasPermission } = useContext(AuthContext);
  const puede = user?.role === "admin" || user?.role === "gerente" || hasPermission?.("retenciones.gestionar_constancias");
  const [lista, setLista] = useState(entidad?.constancias_retencion || []);
  const [saving, setSaving] = useState(false);
  const [cambio, setCambio] = useState(false);

  if (!entidad?.id) return null;
  const anioActual = new Date().getFullYear();
  const upd = (i, k, v) => { setLista(l => l.map((c, j) => (j === i ? { ...c, [k]: v } : c))); setCambio(true); };

  const guardar = async () => {
    setSaving(true);
    try {
      const res = await fetch(`${API}/admin/retenciones/constancias/${entidad.id}`, {
        method: "PUT",
        headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
        body: JSON.stringify({ constancias: lista.map(c => ({ tipo: c.tipo, anio: Number(c.anio), nro: c.nro || null })) }),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(data.detail || "No se pudo guardar");
      setLista(data.constancias_retencion || []);
      setCambio(false);
      toast.success("Constancias guardadas");
    } catch (e) { toast.error(e.message); }
    setSaving(false);
  };

  const inp = "bg-white/5 border border-white/10 rounded-lg px-2 py-1.5 text-xs text-white focus:outline-none disabled:opacity-60";
  return (
    <div className="bg-emerald-900/10 border border-emerald-500/25 rounded-xl p-4 space-y-3">
      <div className="flex items-center gap-2 text-emerald-300 text-xs font-medium">
        <ShieldCheck className="w-4 h-4" /> Constancias de no retención de IVA (por año)
      </div>
      {lista.length === 0 && <p className="text-slate-500 text-[11px]">Sin constancias: si la empresa es agente de retención, se le retendrá según las reglas vigentes.</p>}
      {lista.map((c, i) => (
        <div key={i} className="grid grid-cols-[1fr_80px_1fr_auto] gap-2 items-center">
          <select className={inp} disabled={!puede} value={c.tipo} onChange={e => upd(i, "tipo", e.target.value)}>
            {Object.entries(TIPOS).map(([k, l]) => <option key={k} value={k}>{l}</option>)}
          </select>
          <input type="number" className={inp} disabled={!puede} value={c.anio} onChange={e => upd(i, "anio", e.target.value)} />
          <input className={inp} disabled={!puede} placeholder="N° (opcional)" value={c.nro || ""} onChange={e => upd(i, "nro", e.target.value)} />
          {puede && <button type="button" className="text-slate-500 hover:text-red-400" onClick={() => { setLista(l => l.filter((_, j) => j !== i)); setCambio(true); }}><Trash2 className="w-4 h-4" /></button>}
        </div>
      ))}
      {puede ? (
        <div className="flex gap-2">
          <button type="button" className="px-2.5 py-1.5 rounded-lg bg-white/5 hover:bg-white/10 text-slate-300 text-xs flex items-center gap-1"
            onClick={() => { setLista(l => [...l, { tipo: "exportador", anio: anioActual, nro: "" }]); setCambio(true); }}>
            <Plus className="w-3.5 h-3.5" /> Agregar
          </button>
          {cambio && (
            <button type="button" disabled={saving} onClick={guardar}
              className="px-2.5 py-1.5 rounded-lg bg-emerald-600 hover:bg-emerald-500 disabled:opacity-60 text-white text-xs flex items-center gap-1">
              {saving ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Save className="w-3.5 h-3.5" />} Guardar constancias
            </button>
          )}
        </div>
      ) : (
        <p className="text-slate-600 text-[10px]">Solo lectura (falta el permiso retenciones.gestionar_constancias).</p>
      )}
    </div>
  );
}
